module.exports = __webpack_public_path__ + "static/app_store-0136a720388928d8e475f051feb44530.png";